import { css } from '@emotion/react';
import { Box } from '@inflearn/ds-react-next';

import { HeroStage } from './hero/HeroStage';
import { useAiInterviewHeroUserState } from './hooks/useAiInterviewHeroUserState';
import { Faq } from './landing/Faq';
import { FeatureStack } from './landing/FeatureStack';
import { FloatingBar } from './landing/FloatingBar';
import { Requirements } from './landing/Requirements';
import { useReveal } from './landing/useReveal';

/**
 * 원티드형 스크롤:
 * 히어로 sticky 구간에서 스크롤이 시퀀스(카드 머지 + 카피 등장)를 구동하고,
 * 인계 이후에 아래 섹션이 문서 흐름으로 이어진다.
 */
export const AiInterviewsPageItem = () => {
  const { userState } = useAiInterviewHeroUserState();
  useReveal();

  return (
    <Box css={styles.page}>
      <HeroStage userState={userState} />
      <Box css={styles.content}>
        <FeatureStack />
        <Requirements />
        <Faq />
      </Box>
      <FloatingBar />
    </Box>
  );
};

const styles = {
  page: css({
    position: 'relative',
    background: '#0E1013',
  }),
  content: css({
    position: 'relative',
    zIndex: 1,
  }),
};
